exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-clickable[data-v-0444e554]{pointer-events:none}", ""]);

// exports
